import React, { useEffect, useState } from "react";
import MenuIcon from "../menuIcon";
import { Popover, Spin as BadSpin, SpinProps } from "@gw/web-basic-components";
import { OPERATION } from "./config";
import type { IconProps, TreeItemMenuProps } from "./dto";
import styles from "./index.module.less";

import MenuSvg from "../../assets/icon-menu.svg";

const Spin: React.FC<SpinProps> = BadSpin;
/**
 * 节点操作菜单
 */
export default function ItemMenu(props: TreeItemMenuProps) {
  const [iconsWrapper, setIconsWrapper] = useState<IconProps[]>([]);
  const [icons, setIcons] = useState<IconProps[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 2000);
    return () => clearTimeout(timer);
  }, [loading]);

  useEffect(() => {
    const iconList = [];
    Object.keys(props).forEach((m) => {
      if (props[m] && OPERATION[m]) {
        if (typeof props[m] === "string") {
          OPERATION[m].name = props[m];
        }
        iconList.push(OPERATION[m]);
      }
    });
    setIconsWrapper(iconList);
  }, [props.add, props.edit, props.delete, props.copy, props.config]);

  useEffect(() => {
    setIcons(iconsWrapper.filter((wrapper) => wrapper));
  }, [iconsWrapper]);

  function handleClick(e) {
    e.stopPropagation();
    if (typeof props.handleMenu === "function") {
      if (e.target.dataset.type !== "menu") setLoading(true);
      props.handleMenu(e.target.dataset.type);
    }
  }

  return (
    <div className={styles.treeItem} onClick={handleClick}>
      {icons.length <= 1 ? (
        icons.map(({ icon, name, type }, i) => (
          <MenuIcon
            key={i}
            icon={icon}
            title={name}
            dataType={type}
            style={{ fontSize: "20px", marginLeft: 8 }}
          />
        ))
      ) : (
        <Popover
          placement="bottomLeft"
          content={
            <Spin spinning={loading}>
              <>
                {icons.map((icon, i) => (
                  <div className={styles.popMenu} data-type={icon.type} key={i}>
                    <MenuIcon
                      style={{ fontSize: "20px" }}
                      icon={icon.icon}
                      dataType={icon.type}
                    />
                    <span
                      style={{ marginLeft: 8, verticalAlign: "bottom" }}
                      data-type={icon.type}
                    >
                      {icon.name}
                    </span>
                  </div>
                ))}
              </>
            </Spin>
          }
        >
          <img src={MenuSvg} style={{ marginLeft: 8 }} datatype="menu" />
        </Popover>
      )}
    </div>
  );
}
